export const articles = [
  {
    id: 'a001',
    title: '冬季户外保暖全攻略：从穿衣到装备的科学指南',
    excerpt: '冬季户外活动时，科学保暖比盲目穿厚更重要。本文为您详细解析三层穿衣法的原理，以及如何选择适合的保暖装备，让您在寒冬中也能舒适自如。',
    content: `冬季户外活动不仅是挑战，更是一种享受。然而，如何在零下温度中保持温暖舒适，是每位户外爱好者必须掌握的技能。

## 一、三层穿衣法的科学原理

三层穿衣法是目前公认最科学有效的户外保暖方式：

**内层（排汗层）**：直接接触皮肤，核心功能是快速排汗、保持皮肤干爽。推荐美利奴羊毛或速干合成面料，避免纯棉——因为棉质面料吸汗后不干，会让你感到更冷。

**中层（保暖层）**：核心任务是锁住身体热量。抓绒衣和羽绒服都是优秀的中层选择。热久久户外加热马甲也是绝佳的中层搭配，内置5片发热区域持续提供温暖。

**外层（防护层）**：防风防水，阻挡外部寒冷侵袭。冲锋衣是最常见的外层装备，选择时应关注防水指数和透气性能。

## 二、重点保暖部位

研究表明，人体热量散失最快的部位是头部、颈部和四肢末端。因此：

- **头部**：佩戴保暖帽，可减少约30%的热量散失
- **颈部**：热久久碳纤维发热围巾提供环绕式均匀加热
- **手部**：热久久加热手套，五指独立加热，触屏兼容
- **脚部**：热久久加热鞋垫，让双脚在寒冬中保持温暖

## 三、户外取暖设备的选择

便携取暖设备可以大大提升户外体验。热久久户外暖风机2000W大功率、即开即热，是帐篷露营的最佳取暖伴侣。而热久久强效保暖贴则可以持续发热18小时，是户外长时间作业的理想选择。

## 四、冬季户外活动注意事项

1. 出发前查看天气预报，做好充分准备
2. 携带备用保暖装备，以防万一
3. 保持身体水分，寒冷天气同样容易脱水
4. 注意冻伤预警信号：皮肤发白、麻木、刺痛
5. 合理安排休息时间，避免过度疲劳

做好充分准备，冬季户外同样可以温暖惬意！`,
    category: '使用指南',
    author: '热久久暖身实验室',
    date: '2025-12-15',
    readTime: '8分钟',
    imageQuery: 'Professional outdoor winter hiking scene with warm amber lighting and snowy mountain landscape%2C photographer style%2C soft golden hour light on snow-covered trail%2C modern outdoor lifestyle photography%2C warm tones with cold environment contrast%2C high detail composition',
  },
  {
    id: 'a002',
    title: '保暖贴的正确使用方法与注意事项',
    excerpt: '保暖贴看似简单，但正确的使用方法能让发热效果翻倍。了解保暖贴的工作原理，掌握最佳粘贴位置和注意事项，安全高效享受温暖。',
    content: `保暖贴（也称暖宝宝）是冬季最便捷的保暖产品之一。但很多人使用方式不当，导致发热效果大打折扣，甚至造成低温烫伤。

## 一、保暖贴的工作原理

热久久保暖贴采用铁粉氧化发热技术。打开包装后，铁粉与空气中的氧气接触发生氧化反应，释放热量。这个过程安全可控，不会产生明火，温度稳定维持在52-58°C之间。

## 二、正确使用步骤

**第一步：选择正确时机**
在需要保暖前15-20分钟打开包装，让保暖贴充分接触空气开始发热。

**第二步：选择最佳位置**
- 腰背部：效果最佳，热量可辐射全身
- 腹部：适合经期或腹部寒冷
- 肩颈部：缓解肩颈僵硬
- 脚底：配合热久久加热鞋垫使用效果更佳

**第三步：正确粘贴**
保暖贴必须贴在**内衣外侧**，切勿直接接触皮肤。用衣物作为隔离层，既能保证热量传导，又能防止低温烫伤。

**第四步：定时检查**
建议每隔2小时检查一次粘贴部位的皮肤状况。如出现发红、灼热感，立即取下。

## 三、使用注意事项

1. 睡觉时请勿使用保暖贴，睡眠中无法感知温度变化
2. 请勿与电热毯等其他加热设备同时使用
3. 糖尿病、血液循环障碍患者使用前请咨询医生
4. 儿童使用时需成人全程监护
5. 使用后请妥善丢弃，勿随意抛弃

## 四、常见误区

**误区一**："保暖贴越烫越好"
正解：持续恒温比高温更重要，热久久保暖贴追求的是持久稳定的温暖体验。

**误区二**："保暖贴可以重复使用"
正解：保暖贴是单次使用产品，发热反应不可逆。如需可重复使用的产品，推荐热久久便携暖手宝或加热鞋垫。

正确使用保暖贴，让温暖持久相伴！`,
    category: '使用指南',
    author: '热久久产品专家',
    date: '2025-11-28',
    readTime: '6分钟',
    imageQuery: 'Close-up of person correctly applying warming patch on clothing over lower back%2C lifestyle photography%2C warm cozy indoor setting with soft natural light%2C comfortable winter clothing detail%2C clean modern aesthetic%2C warm amber tones',
  },
  {
    id: 'a003',
    title: '户外工作者冬季保暖方案：从装备到技巧',
    excerpt: '户外工作者的冬天格外漫长。本文将为您提供一份完整的冬季户外工作保暖方案，涵盖核心装备推荐、饮食调理、工作节奏安排等全方位保暖策略。',
    content: `户外工作者的冬季挑战不仅是寒冷，更是要在严寒中保持工作效率和安全。一份科学的保暖方案至关重要。

## 一、核心保暖装备推荐

**上身保暖**
热久久户外加热马甲是户外工作者最值得投资的装备。内置5片发热区域覆盖胸、背、腰部，三档温度调节可根据工作强度灵活调整。搭配防风防水冲锋衣，形成完美的保暖防护系统。

**手部保暖**
热久久加热手套专为需要手部灵活操作的工作设计。五指独立加热、触屏兼容的特性，让您在保暖的同时不影响操作手机或设备。

**脚部保暖**
寒从脚起，热久久加热鞋垫提供10小时续航，无线遥控操作方便，适配各类工作靴。

**应急保暖**
随身携带几片热久久强效保暖贴，18小时持续发热，是应对突发降温的最佳应急方案。

## 二、科学工作节奏

- 合理安排工作与休息的时间比例，建议每工作45分钟休息10分钟
- 休息时进入温暖室内或避风处，补充热饮
- 避免长时间静止站立，适度活动促进血液循环

## 三、饮食调理建议

1. 早餐必须吃好吃饱，提供充足热量
2. 工作期间携带保温杯，随时补充热水
3. 适当增加蛋白质和健康脂肪摄入
4. 姜茶、红糖水是传统有效的驱寒饮品

## 四、安全提醒

- 注意冻伤早期症状：皮肤苍白、麻木、刺痛感
- 如出现严重颤抖、言语不清、意识模糊，可能是体温过低，需立即就医
- 不要在极度疲劳状态下继续户外作业

热久久始终关注户外工作者的保暖需求，让每一位辛勤工作者都能在温暖中高效工作。`,
    category: '户外知识',
    author: '热久久暖身实验室',
    date: '2025-11-10',
    readTime: '7分钟',
    imageQuery: 'Outdoor construction worker in winter wearing heated gear with warm golden sunset lighting%2C professional documentary style photography%2C urban winter setting with soft snow%2C warm industrial aesthetic%2C authentic working scene composition',
  },
  {
    id: 'a004',
    title: '极寒环境下的保暖科技：从被动保暖到主动发热',
    excerpt: '传统保暖依靠增加衣物厚度，而现代发热科技正在改变这一格局。了解从碳纤维到石墨烯的发热技术演进，以及主动发热装备如何重塑寒冷体验。',
    content: `人类与寒冷的斗争由来已久。从兽皮裹身到现代智能发热装备，保暖科技经历了翻天覆地的变化。

## 一、被动保暖的局限

传统保暖方式属于"被动保暖"——通过增加衣物层数来减少热量散失。这种方式虽然有效，但存在明显局限：

1. 衣物厚重影响行动灵活性
2. 静止时保暖效果大幅下降
3. 无法主动补充热量
4. 极端环境下效果有限

## 二、主动发热技术的演进

**第一代：铁粉氧化技术**
热久久保暖贴系列使用的核心技术。通过铁粉与氧气发生的氧化反应释放热量，安全可靠，无需电源。热久久经典保暖贴可持续发热12小时，平均温度53°C。

**第二代：电阻丝加热**
通过内置电阻丝通电发热，需要电池供电。优点是温度可控，缺点是发热不均匀。

**第三代：碳纤维发热**
热久久碳纤维发热围巾使用的核心技术。碳纤维具有发热均匀、轻便柔软、电热转换效率高等优势。

**第四代：石墨烯发热**
目前最前沿的发热技术，电热转换效率接近100%，发热速度极快，且具备远红外理疗功能。

## 三、热久久的科技布局

热久久产品线涵盖了从入门到高端的完整发热技术方案：

- 保暖贴系列：成熟稳定的铁粉氧化技术
- 便携暖手宝：智能温控电阻加热
- 加热服装：多区域碳纤维发热系统
- 加热鞋垫：超薄柔性发热膜

## 四、未来趋势

主动发热技术正朝着更轻、更薄、更智能的方向发展。未来的保暖装备将与可穿戴设备深度融合，实现根据环境温度和人体状态自动调节发热功率的智能保暖体验。

热久久将持续投入研发，让每一次寒冷体验都变成温暖记忆。`,
    category: '产品科技',
    author: '热久久研发中心',
    date: '2025-10-22',
    readTime: '9分钟',
    imageQuery: 'High-tech heating product components with carbon fiber and modern materials on clean warm background%2C product technology photography%2C soft studio lighting with warm glow%2C innovation and technology aesthetic%2C professional commercial shot',
  },
  {
    id: 'a005',
    title: '冬季出行必备清单：从短途到长途的保暖全方案',
    excerpt: '无论是通勤还是长途旅行，一份周到的冬季出行保暖清单都能让旅途更加舒适。从随身暖贴到车载取暖，我们帮您整理好了全部装备。',
    content: `冬季出行，准备工作决定旅途质量。本文为您整理了一份从短途到长途的完整保暖出行清单。

## 一、日常通勤装备（1-2小时）

- 热久久经典保暖贴 × 2片（腰背部+腹部）
- 热久久便携暖手宝 × 1个
- 保暖围巾或热久久碳纤维发热围巾
- 触屏兼容手套
- 保温杯（装热水或姜茶）

每天出门前15分钟贴好保暖贴，到达办公室后暖手宝还能继续使用，一整天都暖暖的。

## 二、周末户外出行（半天至一天）

在上述基础上增加：

- 热久久强效保暖贴 × 4片
- 热久久加热鞋垫（10小时续航无忧）
- 热久久加热手套
- 备用充电宝 × 2（为加热装备提供电力）
- 防风防水冲锋衣
- 高热量零食（巧克力、坚果）

特别提醒：野外活动务必携带备用保暖装备，以防天气突变。

## 三、长途旅行/户外露营（1天以上）

完整装备清单：

- 热久久户外加热马甲（核心装备）
- 热久久户外暖风机（帐篷取暖）
- 热久久全系列保暖贴（各型号备用）
- 加热鞋垫 + 加热手套 + 发热围巾
- 大容量充电宝 × 3
- 急救保温毯
- 全套防寒服装

长途出行建议携带热久久户外暖风机，2000W即开即热，帐篷内温度可快速提升10-15°C。

## 四、出行前检查清单

□ 所有电子加热设备充满电
□ 保暖贴检查保质期
□ 备用充电宝充满电
□ 查看目的地天气
□ 准备应急预案

做好充分准备，冬季出行一样温暖惬意！热久久，让每一次出行都充满温暖。`,
    category: '出行攻略',
    author: '热久久暖身实验室',
    date: '2025-10-05',
    readTime: '7分钟',
    imageQuery: 'Winter travel essentials neatly arranged on warm wooden surface%2C lifestyle flat lay photography%2C soft natural window lighting%2C cozy winter aesthetic with warm amber tones%2C organized travel preparation scene%2C clean modern composition',
  },
  {
    id: 'a006',
    title: '老人冬季保暖特别指南：安全、舒适、科学',
    excerpt: '老年人由于新陈代谢减缓，对寒冷更加敏感。本文从医学角度出发，为老年朋友提供一份安全、舒适、科学的冬季保暖方案，让温暖与健康同行。',
    content: `随着年龄增长，人体对寒冷的调节能力逐渐下降。老年人冬季保暖不仅是舒适问题，更是健康问题。

## 一、老年人为何更怕冷

1. **新陈代谢减缓**：基础代谢率随年龄下降，产热减少
2. **皮下脂肪变薄**：天然保温层减少
3. **血液循环变差**：末梢供血不足，手脚易冷
4. **体温调节能力下降**：对温度变化感知和调节能力减弱

## 二、安全保暖产品推荐

**热久久迷你暖腰贴**：专为腰部设计，符合人体工学弧度。老年人腰部保暖尤为重要，因为腰部受凉会加重腰椎问题。持续发热14小时，全天温暖守护。

**热久久USB暖脚宝**：USB安全低压供电，无触电风险。柔软毛绒内里，自动恒温50°C，非常适合老年人在家看电视、读报时使用。

**热久久便携暖手宝**：操作简单，一键开关，三档温度可视。小巧便携，外出散步随身携带。

## 三、特别注意事项

1. **避免低温烫伤**：老年人皮肤感知能力下降，使用保暖贴时务必贴在内衣外侧，切勿直接接触皮肤。建议使用定时提醒，每2小时检查一次。

2. **室内温度管理**：建议室内温度保持在18-22°C，避免室内外温差过大导致感冒。

3. **谨慎使用电热毯**：如需使用，应在睡前预热，入睡时关闭。

4. **注意保湿**：取暖同时注意室内湿度，建议使用加湿器。

## 四、饮食调理

- 多食用温性食物：生姜、红枣、桂圆、羊肉
- 保证充足蛋白质摄入
- 适量补充维生素D
- 保持充足饮水

温暖相伴，健康相随。热久久用心守护每一位长辈的温暖冬日。`,
    category: '使用指南',
    author: '热久久产品专家',
    date: '2025-09-18',
    readTime: '6分钟',
    imageQuery: 'Elderly person comfortably reading in warm cozy living room with soft natural light%2C lifestyle photography%2C peaceful winter indoor scene%2C warm amber tones and comfortable atmosphere%2C elegant senior lifestyle composition',
  },
];

export const articlesByCategory: Record<string, string[]> = {
  '使用指南': ['a001', 'a002', 'a006'],
  '户外知识': ['a003'],
  '产品科技': ['a004'],
  '出行攻略': ['a005'],
};

export const articleCategories = ['全部', '使用指南', '户外知识', '产品科技', '出行攻略'];